import React from 'react';
import PropTypes from 'prop-types';

const HintText = ({ text }) => {
  return (
    <span
      style={{
        borderBottom: '1px dotted #9B9B9B'
      }}
    >
      {text}
    </span>
  );
};

HintText.propTypes = {
  text: PropTypes.string.isRequired
};

export default HintText;
